export default __webpack_public_path__ + "static/media/Right003.a44ecffb.png";